<template>
  <div class="wrapper">
    <div class="policy-container">
        <h1>Dorsett Controls</h1>
        <h2>
        Privacy Policy &amp; SMS Messaging Consent<br />
        <span class="subtitle">InfoScan SCADA System</span>
        </h2>

        <section>
        <h3>Overview</h3>
        <p>
            Dorsett Controls respects your privacy and is committed to protecting your
            personal information. This policy explains how information is collected,
            used, and protected when users opt in to receive SMS (text message)
            notifications through the InfoScan SCADA system.
        </p>
        </section>

        <section>
        <h3>Information Collected</h3>
        <p>When you opt in to receive SMS notifications, the following information may be collected:</p>
        <ul>
            <li>Mobile phone number</li>
            <li>Name or user identifier (if provided)</li>
            <li>System alert and notification preferences</li>
            <li>Message delivery status and timestamps</li>
        </ul>
        <p>No sensitive personal information is intentionally collected.</p>
        </section>

        <section>
        <h3>Use of Information</h3>
        <p>Information is used solely to deliver operational and system-related notifications, including:</p>
        <ul>
            <li>SCADA alarms and alerts</li>
            <li>System status notifications</li>
            <li>Operational or safety-related messages</li>
        </ul>
        <p>SMS messages are not used for marketing or promotional purposes.</p>
        </section>

        <section>
        <h3>SMS Messaging &amp; Third-Party Service Provider</h3>
        <p>
            SMS notifications are delivered using Twilio, a third-party communications
            service provider. By opting in, you acknowledge that your phone number and
            message content are transmitted through Twilio solely for message delivery.
        </p>
        <p>
            Dorsett Controls does not sell or share personal information for advertising
            or unrelated third-party use.
        </p>
        </section>

        <section>
        <h3>Opt-In Consent</h3>
        <ul>
            <li>Explicit consent to receive automated or system-generated SMS messages</li>
            <li>Message frequency may vary based on system activity</li>
            <li>Standard message and data rates may apply</li>
        </ul>
        <p>
            Opt-in is voluntary and may be required only if SMS alerts are part of your
            assigned operational role.
        </p>
        </section>

        <section>
        <h3>Opt-Out</h3>
        <p>You may opt out of SMS notifications at any time by:</p>
        <ul>
            <li>Replying <strong>STOP</strong> to any SMS message</li>
            <li>Contacting your system administrator</li>
            <li>Disabling SMS notifications within InfoScan, if available</li>
        </ul>
        <p>No further messages will be sent unless you re-enroll.</p>
        </section>

        <section>
        <h3>Data Retention &amp; Security</h3>
        <p>
            Dorsett Controls implements reasonable administrative and technical safeguards
            to protect collected information. SMS-related data is retained only as long
            as necessary for operational, troubleshooting, or compliance purposes.
        </p>
        </section>

        <section>
        <h3>Changes to This Policy</h3>
        <p>
            This policy may be updated periodically. Continued use of SMS notifications
            constitutes acceptance of the revised policy.
        </p>
        </section>

        <section>
        <h3>Contact Information</h3>
        <p class="contact-block">
          <strong style="color:#003366">Dorsett Controls</strong><br />
          <span class="contact-row">
            <span class="contact-label">Phone:</span>
            <a class="contact-link" href="tel:+18553872232">855 DT SCADA (855-387-2232)</a>
          </span><br />
          <span class="contact-row">
            <span class="contact-label">Email:</span>
            <a class="contact-link" href="mailto:support@dorsettcontrols.com">support@dorsettcontrols.com</a>
          </span>
        </p>
        </section>

        <footer>
        © Dorsett Controls. All rights reserved.
        </footer>
    </div>
  </div>
</template>

<script>
export default {
    name: "InfoScanSmsPrivacyPolicy"
};
</script>

<style scoped>
.wrapper {
  background-color: #f5f5f5;
  min-height: 100vh;
}
.policy-container {
  background-color: #FFF;
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
  font-family: Arial, Helvetica, sans-serif;
  color: #333;
  line-height: 1.6;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

h1 {
  color: #003366;
  margin-bottom: 0;
}

h2 {
  color: #003366;
  margin-top: 5px;
  border-bottom: 2px solid #003366;
  padding-bottom: 10px;
}

.subtitle {
  font-size: 0.9em;
  font-weight: normal;
}

h3 {
  margin-top: 30px;
  color: #003366;
}

ul {
  margin-left: 20px;
}

footer {
  margin-top: 40px;
  padding-top: 15px;
  padding-bottom: 15px;
  border-top: 1px solid #ccc;
  font-size: 0.9em;
  color: #555;
  text-align: center;
}

.contact-block {
  margin: 0;
}

.contact-row {
  display: inline-block;
  margin-top: 4px;
}

.contact-label {
  font-weight: 600;
  margin-right: 6px;
  color: #003366;
}

.contact-link {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>
